import { render, staticRenderFns } from "./MarketingConsentsHistory.vue?vue&type=template&id=dbd8c948"
import script from "./MarketingConsentsHistory.vue?vue&type=script&lang=ts"
export * from "./MarketingConsentsHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports